export default "__VITE_ASSET__59ce464c__"